module.exports = __webpack_public_path__ + "static/media/ZIP.3d973141.svg";